<template>
  <v-dialog :value="show" persistent max-width="480">
    <v-card :loading="boxLoading" :disabled="boxLoading">
      <template slot="progress">
        <v-progress-linear
          color="produit"
          height="7"
          indeterminate
        ></v-progress-linear>
      </template>
      <v-card-title class="text-h5"> Ajout </v-card-title>
      <v-card-text v-show="!boxLoading">
        Indiquez l'élément à ajouter au produit ainsi que son matériau
        constitutif.
        <v-autocomplete
          label="Elément"
          :items="elementsPharmat"
          :search-input.sync="elementSearch"
          :loading="elementsLoading"
          v-model="element"
          item-text="libelle"
          item-value="id"
          flat
          clearable
          return-object
        ></v-autocomplete>
        <v-autocomplete
          label="Matériau"
          :items="materiauxPharmat"
          :search-input.sync="materiauSearch"
          :loading="materiauxLoading"
          v-model="materiau"
          item-text="libelle"
          item-value="id"
          flat
          clearable
          return-object
        ></v-autocomplete>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="success"
          text
          @click="$emit('ok', { element, materiau })"
          :disabled="!valid"
        >
          OK
        </v-btn>
        <v-btn color="error" text @click="$emit('cancel')"> Annuler </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import FournisseurService from "@/services/FournisseurService";

export default {
  name: "ProduitElementDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    editedElement: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      //value: false,
      boxLoading: false,
      materiauSearch: null,
      elementSearch: null,
      elementsLoading: false,
      materiauxLoading: false,
      elementsPharmat: null,
      materiauxPharmat: null,
      element: null,
      materiau: null,
    };
  },
  watch: {
    show() {
      if (this.boxLoading) return;
      this.boxLoading = true;

      Promise.all([
        FournisseurService.getElements({ all: true }),
        FournisseurService.getMateriaux({ all: true }),
      ])
        .then((res) => {
          this.elementsPharmat = res[0].data;
          this.materiauxPharmat = res[1].data;
        })
        .catch((err) => {
          if (
            err.response &&
            err.response.status &&
            err.response.status == 401
          ) {
            this.$store.dispatch(
              "setErreur",
              new Error("Vous avez été déconnecté.e")
            );
            this.$router.replace({ name: "home" });
          } else {
            this.$store.dispatch("setErreur", err);
          }
        })
        .finally(() => {
          if (this.editedElement != null) {
            this.element = {
              id: this.editedElement.idElement,
              libelle: this.editedElement.element,
            };
            this.materiau = {
              id: this.editedElement.idMateriau,
              libelle: this.editedElement.materiau,
            };
            this.elementSearch = this.editedElement.element;
            this.materiauSearch = this.editedElement.materiau;
          } else {
            this.element = null;
            this.materiau = null;
          }

          this.boxLoading = false;
        });
    },
    elementSearch(val) {
      if (this.elementsLoading) return;
      this.elementsLoading = true;

      FournisseurService.getElements({ q: val })
        .then((res) => {
          this.elementsPharmat = res.data;
        })
        .catch((err) => {
          if (
            err.response &&
            err.response.status &&
            err.response.status == 401
          ) {
            this.$store.dispatch(
              "setErreur",
              new Error("Vous avez été déconnecté.e")
            );
            this.$router.replace({ name: "home" });
          } else if (
            err.response &&
            err.response.status &&
            err.response.status == 404
          ) {
            this.elementsPharmat = [];
          } else if (err instanceof Error) {
            this.$store.dispatch("setErreur", err);
          }
        })
        .finally(() => {
          this.elementsLoading = false;
        });
    },
    materiauSearch(val) {
      if (this.materiauxLoading) return;
      this.materiauxLoading = true;

      FournisseurService.getMateriaux({ q: val })
        .then((res) => {
          this.materiauxPharmat = res.data;
        })
        .catch((err) => {
          if (
            err.response &&
            err.response.status &&
            err.response.status == 401
          ) {
            this.$store.dispatch(
              "setErreur",
              new Error("Vous avez été déconnecté.e")
            );
            this.$router.replace({ name: "home" });
          } else if (
            err.response &&
            err.response.status &&
            err.response.status == 404
          ) {
            this.materiauxPharmat = [];
          } else if (err instanceof Error) {
            this.$store.dispatch("setErreur", err);
          }
        })
        .finally(() => {
          this.materiauxLoading = false;
        });
    },
  },
  computed: {
    valid() {
      return this.element != null || this.materiau != null;
    },
  },
  methods: {
    validate() {},
  },
};
</script>

<style></style>
